import { addListenersToCheckoutButtons, ga4ProductView } from './ga4-events-scripts.js';

addListenersToCheckoutButtons();
ga4ProductView();